import { combineReducers } from 'redux';

import activityReducer from './ducks/activity';
import failureAnalysisReducer from './ducks/failure-analysis';
import filtersReducer from './ducks/filters';
import general from './ducks/general';
import ownersReducer from './ducks/filters/reducers/owners';
import rootCausesReducer from './ducks/root-causes';
import testErrorReducer from './ducks/test-error';
import testHistoryReducer from './ducks/test-history';
import testHistoryViewsReducer from './ducks/test-history-view';
import testListReducer from './ducks/test-list';
import testOverviewReducer from './ducks/test-overview';
import testSummaryReducer from './ducks/test-summary';
import trendsReducer from './ducks/trends';

const reducers = {
  activity: activityReducer,
  failureAnalysis: failureAnalysisReducer,
  filters: filtersReducer,
  generalReducer: general,
  owners: ownersReducer,
  rootCauses: rootCausesReducer,
  testError: testErrorReducer,
  testHistory: testHistoryReducer,
  testHistoryViews: testHistoryViewsReducer,
  testList: testListReducer,
  testOverview: testOverviewReducer,
  testSummary: testSummaryReducer,
  trends: trendsReducer,
};

export default combineReducers(reducers);
